import { jsxs as n, jsx as c } from "react/jsx-runtime";
import y from "react";
import { ErrorLabel as C, HintLabel as j } from "../Input/styled.js";
import { CheckboxType as l } from "./interfaces.js";
import { Wrapper as o, LabelWrapper as r, InputCheckbox as w, Label as B } from "./styled.js";
const v = y.forwardRef(
  function({
    name: i,
    label: h = "",
    error: t,
    disabled: f,
    checked: $,
    labelProps: d,
    errorLabelProps: e,
    checkboxType: a = l.default,
    width: k = "100%",
    hint: x,
    ...m
  }, u) {
    return /* @__PURE__ */ n(o, { $width: k, $checkboxType: a, children: [
      /* @__PURE__ */ n(r, { children: [
        /* @__PURE__ */ c(
          w,
          {
            "aria-label": h,
            readOnly: !0,
            ...m,
            name: i,
            id: i,
            type: "checkbox",
            checked: $,
            disabled: f,
            "aria-disabled": f,
            "aria-invalid": !!t,
            "aria-labelledby": (d == null ? void 0 : d.id) ?? `${i}.label`,
            ref: u,
            ...t ? { "aria-errormessage": (e == null ? void 0 : e.id) ?? `${i}.errorlabel` } : {}
          }
        ),
        /* @__PURE__ */ c(B, { htmlFor: i, $checkboxType: a, id: `${i}.label`, ...d, children: (d == null ? void 0 : d.children) || h })
      ] }),
      !!t && /* @__PURE__ */ c(r, { children: /* @__PURE__ */ c(C, { id: `${i}.errorlabel`, ...e, children: t }) }),
      x && /* @__PURE__ */ c(j, { children: x })
    ] });
  }
);
export {
  v as BaseCheckbox
};
